/* eslint-disable no-nested-ternary */
import { useSessionByQueueId } from '../../../utils/queries/corporateChargingSessions';
import { localDate } from '../../../utils/dateUtils';
import IEC60309 from '../../../assets/connectorLogos/IEC60309.png';
import _3PIN from '../../../assets/connectorLogos/3PIN.png';
import CCS1 from '../../../assets/connectorLogos/ccs1.png';
import CCS2 from '../../../assets/connectorLogos/ccs2.png';
import CHADEMO from '../../../assets/connectorLogos/chademo.png';
import TYPE2 from '../../../assets/connectorLogos/type_2.png';
import getEnvironment from '../../../utils/getEnvironment';
import { useState } from 'react';
import { Typography, Alert, Spin, Modal } from 'antd';
import { Row, Col, Card } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import {
  ClockCircleOutlined,
  BarcodeOutlined,
  LeftOutlined,
} from '@ant-design/icons';
import { find, toNumber } from 'lodash-es';
import {
  FaBolt,
  FaChargingStation,
  FaTachometerAlt,
  FaMoneyBillAlt,
} from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';
import { RiInfraredThermometerFill } from 'react-icons/ri';
import moment from 'moment';

const { Title, Text } = Typography;

const env = getEnvironment();

let mapAPiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_DEV;
if (env === 'production') {
  mapAPiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_PROD;
} else if (env === 'test') {
  mapAPiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_TEST;
}

function LocationModal({
  cpid,
  longitude,
  latitude,
  isLocationModalVisible,
  changeLocationModalVisible,
}) {
  return (
    <Modal
      title={`Charger #${cpid}`}
      visible={isLocationModalVisible}
      onOk={() => changeLocationModalVisible(false)}
      onCancel={() => changeLocationModalVisible(false)}
      style={{ padding: '0px' }}
      footer={null}
    >
      <img
        alt="example"
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=10&size=400x200&maptype=roadmap
          &markers=${encodeURIComponent(
            `color:0x3A72B3|label:C|${latitude},${longitude}`,
          )}&key=${mapAPiKey}`}
        style={{ width: '100%' }}
      />
    </Modal>
  );
}

function ChargerInfo({ charger, cpid }) {
  const [chargerLocationModalVisible, setChargerLocationModalVisible] =
    useState(false);
  return (
    <>
      <Link to={`/chargepoints/${cpid}`}>
        <Card
          style={{
            textAlign: 'center',
            alignItems: 'center',
            width: '100%',
            border: '1px solid #dcdedf',
            height: '100%',
            padding: 15,
          }}
          actions={[
            <MdLocationOn
              style={{ marginRight: '7px', marginBottom: '-4px' }}
              size={25}
              onClick={(e) => {
                e.preventDefault();
                setChargerLocationModalVisible(true);
              }}
            />,
          ]}
          hoverable
        >
          <Title
            level={4}
            style={{
              margin: '0px',
            }}
          >
            <FaChargingStation
              style={{
                marginRight: '10px',
                marginBottom: '-3px',
                color: '#3678b9',
              }}
            />
            Charger Info
          </Title>

          <Title
            level={4}
            ellipsis
            copyable
            style={{
              color: '#2675b8',
              margin: '15px 6px',
            }}
          >
            {cpid}
          </Title>

          <Title level={5}>{charger?.NAME}</Title>
          <Text style={{ margin: '0px' }} copyable ellipsis>
            {charger?.ADDRESS} ({charger?.LATITUDE}, {charger?.LONGITUDE})
          </Text>
        </Card>
      </Link>

      <LocationModal
        cpid={cpid}
        longitude={charger?.LONGITUDE}
        latitude={charger?.LATITUDE}
        isLocationModalVisible={chargerLocationModalVisible}
        changeLocationModalVisible={setChargerLocationModalVisible}
      />
    </>
  );
}

function EnergyUsage({ kWh = 0 }) {
  return (
    <Card
      style={{
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #dcdedf',
        height: '100%',
        padding: 15,
      }}
      hoverable
    >
      <Title level={4} ellipsis>
        <FaBolt
          style={{
            marginRight: '10px',
            marginBottom: '-5px',
            color: '#3678b9',
          }}
        />
        Energy Consumed
      </Title>

      <Title level={4}>
        <span
          style={{
            // fontFamily: 'UnidreamLED',
            fontSize: 20,
            fontWeight: 500,
            letterSpacing: '5px',
          }}
        >
          {toNumber(kWh).toFixed(2)}
        </span>

        <Text style={{ fontSize: '20px', marginLeft: '5px' }}>kWh</Text>
      </Title>
    </Card>
  );
}

function TimePeriod({ startTime, endTime }) {
  const _startTime = localDate(startTime);
  const _endTime = localDate(endTime);
  const duration = moment
    .duration(new Date(endTime) - new Date(startTime))
    .humanize();

  return (
    <Card
      style={{
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #dcdedf',
        height: '100%',
        alignSelf: 'center',
        padding: 15,
      }}
      hoverable
    >
      <Title level={4}>
        <ClockCircleOutlined
          style={{ marginRight: '10px', color: '#2675b8' }}
        />
        Time Period
      </Title>

      <div
        style={{
          // fontFamily: 'UnidreamLED',
          fontSize: 18,
          fontWeight: 500,
          letterSpacing: '1px',
          marginTop: 20,
          // color: '#3678b9',
        }}
      >
        <div>{_startTime}</div>
        to
        <div>{_endTime}</div>
        {/* {_startTime} &#8212; {_endTime} */}
      </div>
      <div style={{ marginTop: 10 }}>
        <Text style={{ fontSize: '20px', fontWeight: 600 }}>({duration})</Text>
      </div>
    </Card>
  );
}

function StartMeterReading({ meterStart }) {
  return (
    <Card
      style={{
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #dcdedf',
        height: '100%',
        padding: 15,
      }}
      hoverable
    >
      <Title level={4} ellipses>
        <FaTachometerAlt
          style={{
            marginRight: '10px',
            color: '#2675b8',
            marginBottom: '-3px',
          }}
        />
        Start Meter Reading
      </Title>

      <Title level={4}>
        <span
          style={{
            // fontFamily: 'UnidreamLED',
            fontSize: 20,
            fontWeight: 500,
            letterSpacing: '5px',
          }}
        >
          {meterStart}
        </span>

        <Text style={{ fontSize: '20px', marginLeft: '5px' }}>Wh</Text>
      </Title>
    </Card>
  );
}

function EndMeterReading({ meterEnd }) {
  return (
    <Card
      style={{
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #dcdedf',
        height: '100%',
        padding: 15,
      }}
      hoverable
    >
      <Title level={4} ellipses>
        <FaTachometerAlt
          style={{
            marginRight: '10px',
            color: '#2675b8',
            marginBottom: '-3px',
          }}
        />
        End Meter Reading
      </Title>

      <Title level={4}>
        <span
          style={{
            // fontFamily: 'UnidreamLED',
            fontSize: 20,
            fontWeight: 500,
            letterSpacing: '5px',
          }}
        >
          {meterEnd}
        </span>

        <Text style={{ fontSize: '20px', marginLeft: '5px' }}>Wh</Text>
      </Title>
    </Card>
  );
}

function Connector({ connector }) {
  return (
    <Card
      style={{
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #dcdedf',
        height: '100%',
        padding: 15,
      }}
      hoverable
    >
      <Title level={4} ellipses>
        <RiInfraredThermometerFill
          style={{
            marginRight: '10px',
            color: '#2675b8',
            marginBottom: '-3px',
          }}
        />
        Connector
      </Title>

      <Title level={4}>
        <img
          alt="example"
          src={
            connector?.TYPE === 'CCS1'
              ? CCS1
              : connector?.TYPE === 'CCS2'
              ? CCS2
              : connector?.TYPE === 'CHADEMO'
              ? CHADEMO
              : connector?.TYPE === '3PIN'
              ? _3PIN
              : connector?.TYPE === 'IEC60309'
              ? IEC60309
              : TYPE2
          }
          style={{
            width: '100px',
            objectFit: 'cover',
            justifyContent: 'center',
            marginRight: '10px',
          }}
        />
        {connector?.TYPE}{' '}
        <span style={{ fontSize: '20px', color: '#3678b9' }}>
          ({connector?.CONNECTOR_ID})
        </span>
      </Title>
    </Card>
  );
}

function AmountConsumed({ amountConsumed }) {
  return (
    <Card
      style={{
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #dcdedf',
        height: '100%',
        padding: 15,
      }}
      hoverable
    >
      <Title level={4} ellipses>
        <FaMoneyBillAlt
          style={{
            marginRight: '10px',
            color: '#2675b8',
            marginBottom: '-3px',
          }}
        />
        Amount Consumed
      </Title>

      <Title level={4}>
        <span
          style={{
            fontSize: 20,
            fontWeight: 500,
            letterSpacing: '5px',
            marginRight: '10px',
          }}
        >
          ₹
        </span>
        <span
          style={{
            fontSize: 20,
            fontWeight: 500,
          }}
        >
          0{/* {(toNumber(amountConsumed) / 100).toFixed(2)} */}
        </span>
      </Title>
    </Card>
  );
}
function IDTag({ idTag }) {
  return (
    <Card
      style={{
        textAlign: 'center',
        alignItems: 'center',
        border: '1px solid #dcdedf',
        height: '100%',
        padding: 15,
      }}
      hoverable
    >
      <Title level={4} ellipses>
        <BarcodeOutlined
          style={{ marginRight: '5px', marginBottom: 30, color: '#2675b8' }}
        />
        ID Tag
      </Title>

      <Title level={4} copyable ellipsis>
        {idTag}
      </Title>
    </Card>
  );
}

// function TransactionLogsData({ cpid, sessionId }) {
//   return (
//     <Card
//       style={{
//         textAlign: 'center',
//         alignItems: 'center',
//         width: '100%',
//         border: '1px solid #dcdedf',
//         height: '100%',
//       }}
//     >
//       <Title level={4} ellipses>
//         <FaClipboardList
//           style={{
//             marginRight: '10px',
//             color: '#2675b8',
//             marginBottom: '-3px',
//           }}
//         />
//         Transaction Logs
//       </Title>

//       <TransactionLogs cpid={cpid} transactionId={sessionId} fullWidth />
//     </Card>
//   );
// }

export default function SessionDetails({ sessionId, qId }) {
  const { data, isLoading, isError } = useSessionByQueueId(qId);
  const history = useHistory();
  function getConnectorType(connectorId, connectors) {
    return find(connectors, { CONNECTOR_ID: connectorId });
  }

  /* **** Stop Charging States ***** */
  // const initiateStopCharging = useStopRemoteChargingMutation();

  // eslint-disable-next-line consistent-return
  // async function stopCharging(transactionId, CPID) {
  //   try {
  //     const result = await initiateStopCharging.mutateAsync({
  //       ChargerId: CPID,
  //       transactionId,
  //     });
  //     return message.success(result?.data?.status);
  //   } catch (error) {
  //     return message.error(
  //       `Something went wrong: ${error?.response?.data?.error}`,
  //     );
  //   }
  // }

  /* ***************************8***** */

  return (
    <>
      {isError ? (
        <Alert
          message="Failed to fetch information from the server"
          type="error"
          closable
          style={{ marginBottom: '20px' }}
          // onClose={() => }
        />
      ) : null}
      <Spin
        spinning={isLoading}
        tip="Fetching Charging Session info..."
        style={{ marginTop: '40vh' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <LeftOutlined
              style={{ marginRight: '10px', cursor: 'pointer' }}
              onClick={() => history.goBack()}
            />
            <Title level={2} style={{ margin: '0px' }}>
              Session{' '}
              <span style={{ color: '#2375b8' }}>#{data?.TRANSACTIONID}</span>
            </Title>
          </div>
          {/* {data?.METER_STOP === null ? (
            <div>
              <Button
                type="primary"
                size="large"
                onClick={() => {
                  stopCharging(sessionId, data?.CPID);
                }}
                loading={initiateStopCharging.isLoading}
              >
                Stop Chagrging
              </Button>
            </div>
          ) : null} */}
        </div>
        {!isLoading ? (
          <>
            <Row gutter={[16, 16]}>
              <Col xs={6} sm={6} md={3} lg={3}>
                <ChargerInfo charger={data?.CHARGER} cpid={data?.CPID} />
              </Col>
              <Col xs={6} sm={6} md={3} lg={3}>
                <EnergyUsage kWh={data?.KWH_CONSUMED ?? 0} />
              </Col>
              <Col xs={6} sm={6} md={3} lg={3}>
                <AmountConsumed
                  amountConsumed={data?.NOTE?.AMOUNT?.AMOUNT_CONSUMED}
                />
              </Col>
              <Col xs={6} sm={6} md={3} lg={3}>
                <IDTag idTag={data?.IDTAG ?? ''} />
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
              <Col xs={6} sm={6} md={3} lg={3}>
                <Connector
                  connector={getConnectorType(
                    data?.CONNECTORID,
                    data?.CHARGER?.CONNECTORS,
                  )}
                />
              </Col>
              <Col xs={6} sm={6} md={3} lg={3}>
                <StartMeterReading meterStart={data?.METER_START ?? 0} />
              </Col>
              <Col xs={6} sm={6} md={3} lg={3}>
                <EndMeterReading meterEnd={data?.METER_STOP ?? 0} />
              </Col>

              <Col xs={6} sm={6} md={3} lg={3}>
                <TimePeriod
                  startTime={data?.START_TIME}
                  endTime={data?.END_TIME}
                />
              </Col>

              {/* <Col xs={24} sm={24} md={24} lg={24}>
                {sessionId && (
                  <TransactionLogsData
                    cpid={data?.CPID}
                    sessionId={sessionId}
                  />
                )}
              </Col> */}
            </Row>
          </>
        ) : null}
      </Spin>
    </>
  );
}
